import axiosInstance from '../utils/axios-instance';

export const getIsSupplier = async (accountId: string): Promise<boolean> => {
	const response = await axiosInstance.get<boolean>('/Me', {
		params: {q: accountId },
	});

	return response.data;
};